export default __webpack_public_path__ + "static/media/android-FicFun.499d36ff.png";